module.exports = __webpack_public_path__ + "static/media/arrow_forward.405f9f71.svg";